import React from "react";

interface DismissableToastProps {
  message: React.ReactNode;
  onClose: () => void;
}
export const DismissableToastComponent: React.FC<DismissableToastProps> = ({ message, onClose }) => (
  <div>
    <span>{message}</span>
    <button onClick={onClose}>Fechar</button>
  </div>
);